import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class NotasService extends ApiService {
  entityType = EntityType.NOTA;
  url = 'api/notas/';
}
